import { defineMessages } from 'react-intl';

export default defineMessages({
  next: {
    defaultMessage: `Next`,
    id: 'app.start.next.button'
  },
  previous: {
    defaultMessage: `Previous`,
    id: 'app.start.previous.button'
  }
});



// WEBPACK FOOTER //
// ./src/containers/components/messages.js